import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tourpackage-category-list',
  templateUrl: './tourpackage-category-list.component.html',
  styleUrls: ['./tourpackage-category-list.component.sass']
})
export class TourpackageCategoryListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
